import { api } from "@/lib/api";

export async function translateFields(texts) {
  const nonEmpty = Object.fromEntries(
    Object.entries(texts).filter(([, v]) => typeof v === "string" && v.trim())
  );
  if (Object.keys(nonEmpty).length === 0) return { en: {}, fr: {} };
  const { data } = await api.post("/admin/translate", { texts: nonEmpty });
  return data;
}

export async function getProfile() {
  const { data } = await api.get("/admin/profile");
  return data;
}

export async function updateProfile(data) {
  const res = await api.put("/admin/profile", { data });
  return res.data;
}
